<nav class="main-header navbar navbar-expand navbar-white navbar-light">
	<!-- Left navbar links -->
	<ul class="navbar-nav">
		<li class="nav-item"><a class="nav-link" data-widget="pushmenu" href="#" role="button"><i class="fas fa-bars"></i></a></li>

		<li class="nav-item d-none d-sm-inline-block">
			<a [routerLink]="['/main/contacto']" routerLinkActive="active" class="nav-link">CONTACTO</a>
		</li>

		<li class="nav-item d-none d-sm-inline-block">
			<a [routerLink]="['/main/ayuda']" routerLinkActive="active" class="nav-link"><i class="fas fa-question-circle mr-1"></i>AYUDA</a>
		</li>

		<li class="nav-item d-none d-sm-inline-block">
			<a [routerLink]="['/main/ligas']" routerLinkActive="active" class="nav-link"><i class="fas fa-trophy mr-1"></i>MIS LIGAS</a>
		</li>
	</ul>

	<!-- <ul class="navbar-nav ml-auto">
		<li class="nav-item">
			<button class="btn" role="button" (click)="reload()"><i class="fas fa-sync"></i></button>
		</li>
	</ul> -->
</nav>
